import type {ThemeCapabilities} from "./types"

/**
 * Capability defaults shared by every brand unless overridden. A brand that
 * behaves like the majority (currently: RI and Repair Clinic) needs zero
 * entries here; a brand that diverges (currently: Bodewell) only specifies
 * the fields that differ.
 */
export const baseCapabilities: ThemeCapabilities = {
  remediationCtaOrder: "recommendedPrimary",
  chatGreetingIcon: "sparkleMark",
  buttonEmphasis: "sentenceCase",
  buttonFocusRingStyle: "ring",
  landingHeroLayout: "logoMark",
  chatGreetingAlign: "center",
  remediationCopyVariant: "standard",
  supportingText: "muted",
  remediationEmphasis: "regular",
}

export const defineCapabilities = (
  overrides: Partial<ThemeCapabilities> = {},
): ThemeCapabilities => ({
  ...baseCapabilities,
  ...overrides,
})
